"use strict";

define('rs/form/section.view',['require','exports','module','vertebrae','rs/helper'],function (require, exports, module) {
  var Vertebrae = require('vertebrae');
  var helper = require('rs/helper');
  var SectionView = Vertebrae.View.extend({
    templates: {
      'form.section.container': 'renderSectionContainerFragment',
      'content.footer': 'renderFooterFragment',
      'form.section.lock': 'renderLockFragment',
      'form.notification.message': 'renderMessageFragment',
      'form.action': 'renderSectionActionFragment'
    },
    events: {
      'focusout .redactor_editor': 'handleRedactorBlur'
    },
    render: function render() {
      var delegate = this.getDelegate();
      this.$el.html(this.renderSectionContainerFragment(delegate));
      if (delegate.shouldRenderFooter()) {
        this.$el.append(this.renderFooterFragment());
        this.$el.append('<div class="form-section-actions"></div>');
      }
      this.$el.addClass('form-section');
      var that = this;
      setTimeout(function () {
        var links = that.$el.find('a');
        links.each(function () {
          var url = $(this).attr('href');
          if (url) {
            $(this).attr({
              "title": url,
              "aria-label": $(this).text() + ": "
            });
          }
        });
      }, 100);
      if (delegate.isLocked()) {
        this.lock();
      }
    },
    handleRedactorBlur: function handleRedactorBlur() {
      var links = this.$el.find('a');
      links.each(function () {
        var url = $(this).attr('href');
        if (url) {
          $(this).attr({
            "title": url,
            "aria-label": $(this).text() + ": "
          });
        }
      });
    },
    createChildElement: function createChildElement(noAppend) {
      var container = $('<div />').width('100%');
      if (noAppend !== true) {
        this.$el.append(container);
      }
      return container;
    },
    refresh: function refresh() {},
    unload: function unload() {
      this.getDelegate().getSidebarElement().remove();
      this._super.apply(this, arguments);
    },
    show: function show() {
      this.$el.show();
      this.refreshSectionScroll();
      this.refreshSectionActions();
    },
    hide: function hide() {
      this.$el.hide();
    },
    lock: function lock() {
      var delegate = this.getDelegate(),
        message = 'Currently being edited by: ' + delegate.lockOwner();
      this.$el.append(this.renderLockFragment({
        clear: true
      }));
    },
    lockSidebar: function lockSidebar() {
      var $sidebar = this.getDelegate().getSidebarElement(),
        delegate = this.getDelegate();
      $sidebar.addClass('locked').attr('title', 'Currently being edited by: ' + delegate.lockOwner());
    },
    unlock: function unlock() {
      this.$('.section-lock').remove();
      this.$el.find('.form-section-messages').empty();
    },
    unlockSidebar: function unlockSidebar() {
      var $sidebar = this.getDelegate().getSidebarElement();
      $sidebar.removeClass('locked').attr('title', '');
    },
    showUnsavedChangesIcon: function showUnsavedChangesIcon() {
      var $sidebar = this.getDelegate().getSidebarElement();
      $sidebar.addClass('unsaved');
    },
    hideUnsavedChangeIcon: function hideUnsavedChangeIcon() {
      var $sidebar = this.getDelegate().getSidebarElement();
      $sidebar.removeClass('unsaved');
    },
    setCompletePercentage: function setCompletePercentage(el, percent) {
      el.find('.percentage').width(percent + '%');
    },
    refreshSidebarState: function refreshSidebarState() {
      var delegate = this.getDelegate(),
        comments = delegate.getComments() || [],
        valid = delegate.isValid() && !comments.length;
      if (!_.isEmpty(delegate.getSidebarElement())) {
        this.refreshCommentCounter();
        this.setSidebarCompletedState(delegate.getSidebarElement(), valid);
      }
    },
    refreshCommentCounter: function refreshCommentCounter() {
      var delegate = this.getDelegate(),
        comments = delegate.getComments() || [],
        commentIcon = delegate.getSidebarElement().find('.comment-icon');
      if (!comments.length) {
        commentIcon.hide();
      } else {
        commentIcon.show();
        commentIcon.find('.comment-counter').html(comments.length);
      }
    },
    setSidebarCompletedState: function setSidebarCompletedState(el, state) {
      if (state) {
        el.addClass('completed');
        el.removeClass('partial');
      } else {
        el.removeClass('completed');
        el.addClass('partial');
      }
    },
    insertElementAtIndex: function insertElementAtIndex(element, index) {
      var children = this.getDelegate().getChildren();
      if (children.length == 0 || !children[index]) {
        this.$('.empty').before(element);
      } else {
        children[index].getView().$el.prev('.form-object-spacer').before(element);
      }
      this.refreshSectionScroll();
    },
    refreshSectionScroll: function refreshSectionScroll() {},
    refreshSectionActions: function refreshSectionActions() {
      if (this.getDelegate().shouldRenderFooter()) {
        var actions = this.getDelegate().getSectionActions();
        return this.getFormSectionActions().html(this.renderSectionActionFragment(actions));
      }
    },
    getFormSectionActions: function getFormSectionActions() {
      return this.$('.form-section-actions');
    },
    setScrollTop: function setScrollTop(top, animate) {
      var d = Promise.defer();
      if (animate) {
        this.$el.parent().animate({
          scrollTop: top
        }, 500, d.resolve);
      } else {
        this.$el.parent().scrollTop(top);
        d.resolve();
      }
      return d.promise;
    },
    getScrollTop: function getScrollTop() {
      return this.$el.parent().scrollTop();
    }
  });
  module.exports = SectionView;
});

